<template>
  <suc-select-component
    :title="$t('components.fields.month')"
    :options="options"
    :value="value"
    @input="onChangeField"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #no-options>{{ $t("components.fields.no_options") }}</template>
  </suc-select-component>
</template>

<script>
import { SucSelectComponent, SUC_SELECT_CHANGED_EVENT } from "@/components/form";

export default {
  components: {
    SucSelectComponent,
  },
  data() {
    return {
      value: null,
    };
  },
  computed: {
    options() {
      let options = [];
      for (let i = 0; i < 12; i++) {
        options.push({ id: i, label: this.$t(`components.date.month_long[${i}]`) });
      }

      return options;
    },
  },
  methods: {
    onChangeField(option) {
      this.value = option;
      this.$emit(SUC_SELECT_CHANGED_EVENT, this.$deepCopy(this.value));
    },
    clear() {
      this.value = null;
    },
  },
};
</script>

<style scoped></style>
